import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { PrintServices } from "../../../../services/printServices";
import { StockServices } from "../../../../stock/services";

/**
 * Generated class for the TpvTicketSelectedPayIndvPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-invite-discount-element',
  templateUrl: 'tpv-ticket-invite-discount-element.html',
})
export class TpvTicketInviteDiscountElementPage {

  type: any;
  ticket_elements: any = Array();
  percentage: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public printServices: PrintServices,
    public stockServices: StockServices) {
    this.tpvServices.ticket_print = 'indv';

    this.type = this.navParams.get('type');

  }

  ionViewDidLoad() {
    this.ticket_elements = this.globals.objectToArray(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].ticket.list);
  }

  insertArraySelected(element, index) {
    this.changeState(index, 'selected');
  }

  changeState(index, state) {
    this.ticket_elements[index]['state_indv'] = state;
  }

  invite() {
    for (let element of this.ticket_elements) {
      if (element.state_indv == 'selected') {
        var name = name = 'INV. - ' + element.name + ' - invitado';
        element.state_indv = 'invite';
        this.tpvServices.insertTableDiscount(name, -Math.abs(element.price), element.delete, element.count, 'invite', '', 'invite', element.price, element.tax);
      }
    }
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

  ionViewWillUnload() {
    this.tpvServices.cleanTicketIndvSelectedArrayInvite();
    this.tpvServices.ticket_print = 'normal';
  }

  delete(index) {
    this.changeState(index, '');
  }

  applyDiscountPercentage(number) {
    this.percentage = number;
  }

  applyDiscount() {
    this.calculate();
  }

  calculate() {
    for (let element of this.ticket_elements) {
      if (element.state_indv == 'selected') {


        var total = element.price;
        var discounted = (total * this.percentage) / 100;

        var name = this.percentage + '% DES. - ' + element.name + ' - descuento línea';
        element.state_indv = 'linediscount';

        this.tpvServices.insertTableDiscount(name, -Math.abs(discounted), element.delete, element.count, 'linediscount', '', 'linediscount', discounted, element.tax);
      }
    }

    this.navCtrl.pop();
    this.navCtrl.pop();
  }

  classbyplatform(zone) {
    let cssClasses = {};

    if (this.globals.platform_mobile && zone == 'div_principal') {
      cssClasses = {
        'row': true,
      };
    } else if (!this.globals.platform_mobile && zone == 'div_principal') {
      cssClasses = {
        'row': true,
        'card-box': true,
      };
    } else if (this.globals.platform_mobile && zone == 'thead') {
      cssClasses = {
        'bg-white': true,
      };
    }

    return cssClasses;

  }


}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-invite-discount-element/tpv-ticket-invite-discount-element.ts